import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';

import LoadingWrapper from './styles';

const LoadingPage = ({
  fullHeight,
  className,
  spinnerProps,
}) => (
  <LoadingWrapper className={className} $fullHeight={fullHeight}>
    <CircularProgress {...spinnerProps} />
  </LoadingWrapper>
);

LoadingPage.propTypes = {
  fullHeight: PropTypes.bool,
  className: PropTypes.string,
  spinnerProps: PropTypes.object,
};

LoadingPage.defaultProps = {
  fullHeight: true,
  className: '',
  spinnerProps: {
    size: 25,
  },
};

export default LoadingPage;
